<template>

    <div class="container textAlignCenter">

        <!--<h3 class="textAlignCenter red padding">No matching results</h3>-->
        <h2 class="textAlignCenter red padding">We're sorry </h2>

        <div v-show="issue === 'weights'">
            <!--<span class="icon-error paddingWarning red textAlignCenter font42 column10"></span>-->
                <h3 class="padding">No matching paper weight results for selections:</h3>
            <p>Product: {{printJob.printJobSpec.name}}</p>
        </div>

        <div v-show="issue === 'laminations'">
            <!--<span class="icon-error paddingWarning red textAlignCenter font42 column10"></span>-->
            <h3 class="padding">No matching lamination results for selections:</h3>
            <p>Product: {{printJob.printJobSpec.name}}</p>
            <p>Paper Weight: {{printJob.printJobSpec.stockWeight}}</p>
        </div>

        <div v-show="issue === 'quantities'" class="padding">
            <!--<span class="icon-error paddingWarning red textAlignCenter font42 column10"></span>-->
            <h3 class="padding">No matching quantity results for selections:</h3>
            <p>Product: {{printJob.printJobSpec.name}}</p>
            <p>Paper Weight: {{printJob.printJobSpec.stockWeight}}</p>
            <p>Lamination: {{printJob.printJobSpec.lamination}}</p>
        </div>
        <div class="padding">

            <div class="overflowContainer">
                <el-button class="centerContainer redButton ravensworthButtons" v-on:click="back()">Revise Print Options
                </el-button>
            </div>

            <div class="">

                <div class="padding">
                    <p>Please contact our team who will be happy to review your template<br> and enable you to print with
                        us.</p>
                    <div class="paddingTopSmall">
                        <p>Ravensworth Client Services:</p>
                        <p class="teal">01670 739606</p>
                        <p class="teal">client.support@ravensworth.co.uk</p>
                    </div>
                </div>

                    <div class="padding">
                        <p>Please close this window</p>
                    </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Router from '../router';
    import Axios from 'axios';

    export default {
        name: "noresultsfound",
        components: {},
        props: {
            printJob: {},
            issue: ''
        },
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
            back() {

                const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id + '?resetJobSpec=true'


                const emptyJobSpec = {
                    "printJobSpec": {
                    }
                }

                Axios.put(url, emptyJobSpec, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response)
                        this.printJob = response.data

                        Router.push({
                            name: 'wizardSelections',
                            params: {
                                printJob: this.printJob
                            }
                        });
                    })
            },
            backQuote() {

                const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id + '?resetJobSpec=true'


                const emptyJobSpec = {
                    "printJobSpec": {
                    }
                }

                Axios.put(url, emptyJobSpec, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response)
                        this.printJob = response.data

                        Router.push({
                            name: 'quoteSelections',
                            params: {
                                quoteJob: this.printJob
                            }
                        });
                    })
            }
        }
    };
</script>